/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Bonisoft Backend API
 * Bonisoft Backend API
 * OpenAPI spec version: 1
 */

export type ShopModuleType = typeof ShopModuleType[keyof typeof ShopModuleType];


export const ShopModuleType = {
  TaxFreeBenefit: 'TaxFreeBenefit',
  DirectPayout: 'DirectPayout',
  VoucherShop: 'VoucherShop',
  CompanyPension: 'CompanyPension',
  TaxFreeBenefitBonus: 'TaxFreeBenefitBonus',
  FullPayout: 'FullPayout',
} as const;
